@if (loader) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
<div class="modal-header">
    <h3 class="modal-title">
        Posting Partners
        <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
        <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    </h3>
</div>
<div class="modal-body" [hidden]="minimise">
    <div class="mainContainer">
        <div style="width: 97.5% !important">
            <div>
                <form [formGroup]="form" novalidate>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-3 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="TAX_YEAR">Tax Year</label>
                                    <input id="TAX_YEAR" type="text" formControlName="TAX_YEAR" class="form-control" readonly />
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="COMBINATION_KEY">Combination Key</label>
                                    <input id="COMBINATION_KEY" type="text" formControlName="COMBINATION_KEY" class="form-control" readonly />
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="PTR_COMBINATION_KEY">Partner Combination Key</label>
                                    <input id="PTR_COMBINATION_KEY" type="text" formControlName="PTR_COMBINATION_KEY" class="form-control" readonly />
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="IS_CURRENT">Is Current Flag</label>
                                    <select id="IS_CURRENT" formControlName="IS_CURRENT" class="form-control">
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="a-modal-footer modal-footer pad-zero" [hidden]="minimise" style="display: flex; align-items: center; width: 100%;">
    @if (!totalLoading) {
<div id="placeholder-field" class="placeholder-field" style="margin-right: auto;">
        <label style="font-size: .85rem; font-weight: 500; margin: 0;">Number of Transactions: {{totalTransactions}}</label>
    </div>
}
    @if (totalLoading) {
<ap-loading style="margin-right: auto;" [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
    <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3" [btnType]="'primary'"
        (onClick)="cancel()">
    </ap-button>
    <ap-button [btnType]="'primary'" [label]="'SAVE'" class="ap-mr-spacing-3"
        (onClick)="save()"></ap-button>
</div>
